import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=e0d8d1a8&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=e0d8d1a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0d8d1a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e0d8d1a8')) {
      api.createRecord('e0d8d1a8', component.options)
    } else {
      api.reload('e0d8d1a8', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=e0d8d1a8&scoped=true&", function () {
      api.rerender('e0d8d1a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8p97YwfJSlMY0/JS/comp/SearchFilterTokens.vue"
export default component.exports